export const mapPairingTypeToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
  }));

  return result;
};

export const pairingTypeColumns = [
  { key: "name", label: "Name", align: "center" },
];
